import getTimeRemaining from './getTimeRemaining';

export default function hasCutOffTimePassed(cutOffTime) {
  const timeRemaining = getTimeRemaining(cutOffTime);
  return !!(cutOffTime && timeRemaining <= 0);
}
